/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import store, { updateModuleState } from '@/store';
import RootStateType from '@/store/types';
import generateMutations from '@/store/generate-mutations';
import { Module } from 'vuex';

import type { StateType } from './types';

const moduleStore: Module<StateType, RootStateType> = {
  namespaced: true,
  state: {
    formData: {
      userName: '',
      idCardNo: '',
    },
  },
};

/** 二要素store对外清晰化ts类型的actions调用 */
export const twoFactorStoreActions = {
  updateFormData: (formData: StateType['formData']): Promise<void> => updateModuleState('twoFactor', {
    formData,
  }) as Promise<void>,
};

store.registerModule(
  'twoFactor',
  generateMutations<StateType>(moduleStore),
  {
    preserveState: false,
  },
);
